"use strict";
// packages/contracts/src/financeiro.ts — Fase 07, Plano 01 (OMIE-07, OMIE-08, D-01, D-02, D-04).
// Contratos de dados financeiros enriquecidos de clientes (camada de leitura restrita a Gestão).
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=financeiro.js.map